import AnalyticsTriggers from '../analytics/analyticsTriggers';

function triggerSoldOutSizeAnalytics({
  productPageState, sizeType, label,
}) {
  let selectedAvailableSizeTile;

  const sizeGroup = sizeType === 'primary'
    ? productPageState.collectionData?.primarySizeGroup
    : productPageState.collectionData?.secondarySizeGroup;
  const selectedSoldOutSizeInfo = `${sizeGroup}:${label}`;

  if (sizeType === 'primary') {
    const secondarySizeArray = productPageState.collectionData?.secondarySizeArray;
    const selectedAvailableSecondary = secondarySizeArray?.find(
      (s) => s.selected && s.available,
    );

    if (selectedAvailableSecondary) {
      const secondarySizeGroup = productPageState.collectionData?.secondarySizeGroup;
      const secondarySizeLabel = selectedAvailableSecondary.label;

      selectedAvailableSizeTile = `${secondarySizeGroup}:${secondarySizeLabel}`;
    }
  } else if (sizeType === 'secondary') {
    const primarySizeArray = productPageState.collectionData?.primarySizeArray;
    const selectedAvailablePrimary = primarySizeArray?.find(
      (s) => s.selected && s.available,
    );

    if (selectedAvailablePrimary) {
      const primarySizeGroup = productPageState.collectionData?.primarySizeGroup;
      const primarySizeLabel = selectedAvailablePrimary.label;

      selectedAvailableSizeTile = `${primarySizeGroup}:${primarySizeLabel}`;
    }
  }
  const productSizeInfo = selectedAvailableSizeTile !== undefined ? `${selectedAvailableSizeTile}-${selectedSoldOutSizeInfo}` : selectedSoldOutSizeInfo;

  AnalyticsTriggers.soldOutSizeTileClick(productPageState, productSizeInfo);
}

export default triggerSoldOutSizeAnalytics;
